export const PAGE_SIZE_DEFAULT = 10;
export const PAGE_SIZE_SMALL = 20;
export const PAGE_SIZE_MEDIUM = 35;
export const PAGE_SIZE_LARGE = 50;
export const PAGE_SIZE_XLARGE = 100;

export const DEFAULT_PAGE_SIZES = [PAGE_SIZE_DEFAULT, PAGE_SIZE_SMALL, PAGE_SIZE_MEDIUM, PAGE_SIZE_LARGE];

export const CONTENT_MANAGEMENT_PAGE_SIZES = [PAGE_SIZE_SMALL, PAGE_SIZE_LARGE, PAGE_SIZE_XLARGE];
